// The save dialog of the Profile screen as a hook (owner 2026-11-02: Onboarding shows its blocks / confirmations /
// server rejections through the SAME mechanism). Moved from Profile.jsx unchanged: one dialog at a time; open() resolves
// with the answer (true = the primary button) when it closes; showBlock / askConfirm keep their texts and titles.
import React, { useCallback, useRef, useState } from 'react';
import ProfileDialog, { dialogText } from './ProfileDialog';

export default function useSaveDialog() {
  const [dialog, setDialog] = useState(null);
  const resolveRef = useRef(null);
  const close = useCallback((answer) => {
    const resolve = resolveRef.current;
    resolveRef.current = null;
    setDialog(null);
    if (resolve) resolve(!!answer);
  }, []);
  const open = (d) => new Promise((resolve) => { resolveRef.current = resolve; setDialog(d); });
  const showBlock = (text, title = 'לא ניתן לשמור') => { open({ kind: 'block', title, message: dialogText(text) }); };
  const askConfirm = (title, text) => open({ kind: 'confirm', title, message: dialogText(text) });
  return { open, showBlock, askConfirm, element: <ProfileDialog dialog={dialog} onClose={close} /> };
}
